// extracted by mini-css-extract-plugin
module.exports = {"logo":"_3Djc4bT5n8_EdlMyUxExm4"};